import React, { FC } from 'react'
import { Box, Grid } from 'transfix-ui/core'
import Skeleton from 'transfix-ui/core/Skeleton'
import { Switch } from 'transfix-ui'

// Skeleton UI of each row
const LoadingRow: FC = () => (
  <Box padding={1}>
    <Grid container direction='row' justifyContent='space-between'>
      <Grid item xs={1}>
        <Skeleton width='100%' component='div' />
      </Grid>
      <Grid item xs={2}>
        <Skeleton width='100%' component='div' />
      </Grid>
      <Grid item xs={1} />
      <Grid item xs={2}>
        <Skeleton width='100%' component='div' />
      </Grid>
      <Grid item xs={2}>
        <Skeleton width='100%' component='div' />
      </Grid>
      <Grid item xs={2}>
        <Box display='flex' justifyContent='center'>
          <Switch disabled />
        </Box>
      </Grid>
    </Grid>
  </Box>
)

/**
 * Loading state of Fuel Surcharge rows
 */
const Loader: FC = () => (
  <Box padding={1}>
    <LoadingRow />
    <LoadingRow />
    <LoadingRow />
    <LoadingRow />
    <LoadingRow />
    <LoadingRow />
    <LoadingRow />
  </Box>
)

export default Loader
